import { STANDARD_REPORT_URL } from '../../../../const/routes';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import {
  CAMPAIGN_COLUMN,
  CATEGORY_COLUMN,
  CUSTOMER_COLUMN,
  EMPLOYEE_COLUMN,
  NUMBER_OF_SOLD_GOODS_COLUMN, PAYMENT_TYPE_CARD,
  PAYMENT_TYPE_CASH, PAYMENT_TYPE_SWISH,
  PRODUCT_COLUMN,
  QUANTITY_COLUMN, SALES_EXCL_VAT, SALES_INCL_VAT,
  SUPPLIER_COLUMN,
  TOTAL_PRICE_INCL_VAT_COLUMN,
  TOTAL_PROFIT_EXCL_VAT,
} from '../standard/StandardReportConsts';

export const SALES_COMPARISONS = {
  urlPath: `${STANDARD_REPORT_URL}/sales-comparisons`,
  reportName: 'SalesPerCategory',
  reportTitle: <FormattedMessage
    id="menu.main.reports.comparisons"
    defaultMessage="Sales comparisons"
  />,
  serverName: 'SalesComparisons',
};

export const COMPARISON_REPORT_LIST = (formatMessage) => [
  {
    value: 'SalesPerCategory',
    label: formatMessage({ id: 'report.title.SalesPerCategory', defaultMessage: 'Sales per category' }),
  },
  {
    value: 'SalesPerCategoryAndEmployee',
    label: formatMessage({
      id: 'report.title.SalesPerCategoryAndEmployee',
      defaultMessage: 'Sales per category and employee',
    }),
  },
  {
    value: 'SalesPerCategoryAndCustomer',
    label: formatMessage({
      id: 'report.title.SalesPerCategoryAndCustomer',
      defaultMessage: 'Sales per category and customer',
    }),
  },
  {
    value: 'SalesAndPaymentsPerCategory',
    label: formatMessage({
      id: 'report.title.SalesAndPaymentsPerCategory',
      defaultMessage: 'Sales and payments per category',
    }),
  },
  {
    value: 'SalesPerSupplier',
    label: formatMessage({ id: 'report.title.SalesPerSupplier', defaultMessage: 'Sales per supplier' }),
  },
  {
    value: 'SalesPerSupplierAndProduct',
    label: formatMessage({
      id: 'report.title.SalesPerSupplierAndProduct',
      defaultMessage: 'Sales per supplier and product',
    }),
  },
  {
    value: 'SalesPerCampaign',
    label: formatMessage({ id: 'report.title.SalesPerCampaign', defaultMessage: 'Sales per campaign' }),
  },
];

export const COMPARISON_REPORT_HEADERS = [
  {
    name: 'SalesPerCategory',
    headers: [CATEGORY_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, TOTAL_PROFIT_EXCL_VAT, SALES_INCL_VAT],
  },
  {
    name: 'SalesPerSupplier',
    headers: [SUPPLIER_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, TOTAL_PROFIT_EXCL_VAT, SALES_INCL_VAT],
  },
  {
    name: 'SalesPerSupplierAndProduct',
    headers: [SUPPLIER_COLUMN, PRODUCT_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, TOTAL_PROFIT_EXCL_VAT, SALES_INCL_VAT],
  },
  {
    name: 'SalesPerCampaign',
    headers: [CAMPAIGN_COLUMN, PRODUCT_COLUMN, QUANTITY_COLUMN, TOTAL_PRICE_INCL_VAT_COLUMN, SALES_INCL_VAT],
  },
  {
    name: 'SalesAndPaymentsPerCategory',
    headers: [CATEGORY_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, SALES_INCL_VAT, SALES_EXCL_VAT, PAYMENT_TYPE_CASH, PAYMENT_TYPE_CARD, PAYMENT_TYPE_SWISH],
  },
  {
    name: 'SalesPerCategoryAndEmployee',
    headers: [CATEGORY_COLUMN, EMPLOYEE_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, TOTAL_PROFIT_EXCL_VAT, SALES_INCL_VAT],
  },
  {
    name: 'SalesPerCategoryAndCustomer',
    headers: [CATEGORY_COLUMN, CUSTOMER_COLUMN, NUMBER_OF_SOLD_GOODS_COLUMN, TOTAL_PROFIT_EXCL_VAT, SALES_INCL_VAT],
  },
];

export const getDefinedHeaders = (report) => {
  return COMPARISON_REPORT_HEADERS.find(({ name }) => report === name).headers;
};